import { AuthContext } from 'context/authContext';
import React from 'react';
import styled from 'styled-components/macro';
import { useContextHook } from 'use-context-hook';

const ButtonGroup = styled.div`
  display: inline-flex;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  margin-top: 22px;
`;

const ToggleButton = styled.button`
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  background-color: ${props => (props.active ? '#16a34a' : 'transparent')};
  color: ${props => (props.active ? 'white' : '#6b7280')};
  font-weight: ${props => (props.active ? '600' : '500')};
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
  margin: 0 2px;

  &:hover {
    background-color: ${props => (props.active ? '#15803d' : '#f3f4f6')};
    color: ${props => (props.active ? 'white' : '#374151')};
  }

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
`;

const ToggleButtons = () => {
  const { activeButtons, setActiveButtons } = useContextHook(AuthContext, {
    activeButtons: 1,
    setActiveButtons: 1,
  });

  const handleToggle = index => {
    setActiveButtons(activeButtons.map((_, i) => (i === index ? !_[index] : false)));
  };

  return (
    <ButtonGroup>
      {['Turno 1', 'Turno 2', 'Turno 3'].map((label, index) => (
        <ToggleButton key={index} active={activeButtons[index]} onClick={() => handleToggle(index)}>
          {label}
        </ToggleButton>
      ))}
    </ButtonGroup>
  );
};

export default ToggleButtons;
